import {
	ADMINGENERATEKEY_SUCCESS,
	ADMINGENERATEKEY_FAILED,
	RESET_ADMINGENERATEKEY,
	LOADING_ADMINGENERATEKEY,
	NETWORK_ERROR_ADMINGENERATEKEY
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGenerateKey = () => {
	return { type: RESET_ADMINGENERATEKEY };
};

const adminGenerateKey = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGENERATEKEY });
	await adminServices
		.post("generateKey", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGenerateKeysuccess(res.data));
					break;
				default:
					dispatch(adminGenerateKeyFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGENERATEKEY,
				payload: err
			});
		});
};
function adminGenerateKeysuccess(data) {
	return {
		type: ADMINGENERATEKEY_SUCCESS,
		payload: data
	};
}
function adminGenerateKeyFailed(data) {
	return {
		type: ADMINGENERATEKEY_FAILED,
		payload: data
	};
}

export { resetAdminGenerateKey, adminGenerateKey };
